var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 17C11.6438 17 10.125 15.47 10.125 13.6C10.125 11.73 11.6438 10.2 13.5 10.2C15.3562 10.2 16.875 11.73 16.875 13.6C16.875 15.47 15.3562 17 13.5 17ZM23.625 13.94C23.625 7.769 19.1531 3.4 13.5 3.4C7.84688 3.4 3.375 7.769 3.375 13.94C3.375 17.918 6.66562 23.188 13.5 29.478C20.3344 23.188 23.625 17.918 23.625 13.94ZM13.5 0C20.5875 0 27 5.474 27 13.94C27 19.584 22.4944 26.265 13.5 34C4.50563 26.265 0 19.584 0 13.94C0 5.474 6.4125 0 13.5 0Z","fill":"#38B2B1"}));
}

Pin.defaultProps = {"width":"27","height":"34","viewBox":"0 0 27 34","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
